import Vue from 'vue';
import Dayjs from '@/plugins/day';
import axios from 'axios';
import gettext from '@/plugins/vue-gettext';
import validator from '@/plugins/vee-validate';
import VSelect from 'vue-select';
import VueMq from 'vue-mq';
import router from '@/router';
import store from '@/store';
import App from '@/App.vue';
import svgSymbolSpriteLoader from 'svg-symbol-sprite-loader';
import SvgSprite from '@/components/SvgSprite.vue';
import InputPad from '@/components/InputPad.vue';
import 'whatwg-fetch';
import mixins from '@/plugins/mixins';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

if(!process.env.VUE_APP_ENV || process.env.VUE_APP_ENV == 'prod') {
  import('@sentry/browser')
  .then(Sentry => {
    import('@sentry/integrations')
    .then(integration => {
      Sentry.init({
        dsn: 'https://90d1bfa99c9a49cba7ffdc2853dccc76@o411349.ingest.sentry.io/5337958',
        integrations: [new integration.Vue({Vue, attachProps: true})],
      });
    });
  });

}

Vue.config.productionTip = false;
svgSymbolSpriteLoader({ useCache: process.env.NODE_ENV === 'production' });

/* Plugins */
Vue.use(Dayjs, {
  lang: 'en',
  filters: {
    ago: 'ago',
  },
});
Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },
});

Vue.filter('currency', (amount, forceDecimal = false) => {
  const EPSILON = 0.00001;
  const decimalType = store.state.auth.currency.decimalType;
  let decimalCount = (decimalType || forceDecimal) ? 2 : 0;
  let decimalSeparator = '.';
  let thousandSeparator = ',';
  if(store.state.auth.user && store.state.auth.user.location) {
    decimalSeparator = store.state.auth.user.location.decimalSeparator
    thousandSeparator = store.state.auth.user.location.thousandSeparator
  }
  const symbol = store.state.auth.currency.symbol;
  try {
    const negativeSign = amount < 0 ? '-' : '';

    const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    const j = (i.length > 3) ? i.length % 3 : 0;

    if(+(Math.abs(amount - i)) < EPSILON) {
        decimalCount = 0;
    }

    return negativeSign + symbol + (j ? i.substr(0, j) + thousandSeparator : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousandSeparator}`) + (decimalCount ? decimalSeparator + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '');
  } catch (e) {
    console.log(e);
  }
  return amount;
});

Vue.filter('decimal', (value, force2decimal = false) => {
  const decimalType = store.state.auth.currency.decimalType;
  if (!force2decimal && !decimalType) {
    return value;
  }
  return +(`${Math.round(`${value}e+2`)}e-2`);
});

/* Components */
Vue.component('v-select', VSelect);
Vue.component('icon', SvgSprite);
Vue.component('input-pad', InputPad);
Vue.component('datetime', Datetime);

new Vue({
  gettext,
  router,
  store,
  validator,
  render: h => h(App),
}).$mount('#app');
